export default __webpack_public_path__ + "static/media/requestTPTQuotation.c074bb22.svg";